var map = {
	"./AG.svg": 102,
	"./AI.svg": 103,
	"./AU.svg": 104,
	"./BE.svg": 105,
	"./BL.svg": 106,
	"./BS.svg": 107,
	"./FR.svg": 108,
	"./GE.svg": 109,
	"./GL.svg": 110,
	"./GR.svg": 111,
	"./JU.svg": 112,
	"./LU.svg": 113,
	"./NE.svg": 114,
	"./NW.svg": 115,
	"./OW.svg": 116,
	"./SG.svg": 117,
	"./SH.svg": 118,
	"./SO.svg": 119,
	"./SZ.svg": 120,
	"./TG.svg": 121,
	"./TI.svg": 122,
	"./UR.svg": 123,
	"./VD.svg": 124,
	"./VS.svg": 125,
	"./ZG.svg": 126,
	"./ZH.svg": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;